export default __webpack_public_path__ + "static/media/Grid design-pana 1.61656e49.svg";